// extracted by mini-css-extract-plugin
module.exports = {"header":"PropertyData_header__3GqoF","listItem":"PropertyData_listItem__3WlZK"};